module.exports = __webpack_public_path__ + "img/undraw_progress_indicator.9d7006f1.svg";